/**
 * 模型参数类型定义
 * 定义了视频生成模型支持的各种参数选项
 */

// 方向比例选项
export const OrientationRatio = {
  RATIO_AUTO: 'auto',
  /** 3.5 Fast 选 Auto 时提交的后端值 */
  RATIO_ADAPTIVE: 'adaptive',
  RATIO_1_1: '1:1',
  RATIO_2_3: '2:3',
  RATIO_3_4: '3:4',
  RATIO_9_16: '9:16',
  RATIO_21_9: '21:9',
  RATIO_3_2: '3:2',
  RATIO_4_3: '4:3',
  RATIO_16_9: '16:9'
} as const

export type AspectRatioValues = (typeof OrientationRatio)[keyof typeof OrientationRatio]

// 时长选项（秒）
export enum Duration {
  DURATION_5S = '5',
  DURATION_8S = '8',
  DURATION_10S = '10',
  DURATION_15S = '15'
}

// 分辨率选项
export enum Resolution {
  HD = 'HD',
  RESOLUTION_720P = '720p',
  RESOLUTION_1080P = '1080p',
  RESOLUTION_2K = '2K'
}

// 方向选项配置
export interface OrientationOption {
  value: AspectRatioValues
  label: string
  icon?: React.ReactNode
  width?: number
  height?: number
}

// 时长选项配置
export interface DurationOption {
  value: Duration
  label: string
}

// 分辨率选项配置
export interface ResolutionOption {
  value: Resolution
  label: string
}

// 方向选项的动态状态配置
export interface OrientationState {
  value: AspectRatioValues
  disabled: boolean
  selected: boolean
}
